<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="img/RevLogo.png" width="200" style="padding-right: 10px;" />
    </template>\
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>Account</strong>
      </b-dropdown-header>
      <b-dropdown-item disabled>
        <i class="fa fa-bell-o" /> Updates
        <b-badge variant="info">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-envelope-o" /> Messages
        <b-badge variant="success">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-tasks" /> Tasks
        <b-badge variant="danger">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center">
        <strong>Settings</strong>
      </b-dropdown-header>
      <b-dropdown-item disabled to="/UserProfile">
        <i class="fa fa-user" />Profile
      </b-dropdown-item>
      <b-dropdown-item disabled>
        <i class="fa fa-wrench" /> Options
      </b-dropdown-item>

      <b-dropdown-item>
        <i class="fa fa-file" /> Open Orders
        <b-badge variant="primary">{{ openOrders }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item disabled>
        <i class="fa fa-shield" /> Lock Account
      </b-dropdown-item>
      <b-dropdown-item @click="logout">
        <i class="fa fa-lock" />
        Logout
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import { mapState, mapGetters } from "vuex";
export default {
  name: "DefaultHeaderDropdownAccnt",
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return {
      itemsCount: 0
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("n_user/logout").then(
        this.$router.push({
          name: "Login"
        })
      );
    }
  },
  computed: {
    ...mapState(["campaign"]),
    ...mapGetters({ openOrders: "campaign/OpenOrders" })
  }
};
</script>
